module.exports = __webpack_public_path__ + "static/media/017-cloud-storage.b24efe9c.svg";